import SubsectionTech from "./SubsectionTech";

const AllSkills = [
  ...new Set(
    [
      ...SubsectionTech.Language,
      ...SubsectionTech.Android,
      ...SubsectionTech.Frontend,
      ...SubsectionTech.Backend,
      ...SubsectionTech.Design,
      ...SubsectionTech.DevOps,
      ...SubsectionTech.Database,
      ...SubsectionTech.IOS,
      ...SubsectionTech.Cloud,
      ...SubsectionTech.Multiplatform,
      ...SubsectionTech.GameDev,
      ...SubsectionTech.Containerisation,
      ...SubsectionTech.Desktop,
      ...[
        "Cybersecurity",
        "Metasploit",
        "Dark Web",
        "Ethical Hacking",
        "ML/AI",
        "TensorFlow",
        "PyTorch",
        "Keras",
        "Scikit-Learn",
        "Machine Learning",
        "Artificial Intelligence",
        "NLTK",
        "SpaCy",
        "Gensim",
        "Jupyter",
        "Pandas",
        "Numpy",
        "Seaborn",
        "Matplotlib",
        "Plotly",
        "Bokeh",
        "Holo Views",
        "Intake",
        "Apache Spark",
        "Tableau",
        "Power BI",
        "D3js",
        "Hadoop",
        "AWS",
        "Android",
        "IOS",
        "GCP",
        "Linux",
        "CSS",
        "Redux",
        "Shopify",
        "Elementor",
        "Frappe",
        "Zod",
        "HuggingFace",
        "LLMs",
        "Generative AI",
        "Rabbit MQ",
        "Kafka",
        "Zustand",
        "Webflux",
        "Reactor",
        "JUnit",
        "Mockito",
        "PowerMock",
        "Cypress",
        "Mocha",
        "Chai",
        "Networking",
        "Java J2SE",
        "Java JEE",
        "Neural Networks",
        "LoRA",
        "LangChain",
        "Chroma",
        "LlamaIndex",
        "RAG",
        "Jest",
        "Playwright",
        "Yii2",
        "S3",
        "REST API",
        "GRPC",
        "WS02 API",
        "Redhat",
        "CentOS",
        "SOAP",
      ],
    ].sort()
  ),
];

export default AllSkills;
